import styled from 'styled-components';
import THEME from '../theme';
const MenuItem = styled.div `
  margin-left: ${THEME.GRID_SPACING * 2}px;
  color: ${THEME.COLOR_PRIMARY}
  display: inline-block;
  position: relative;
  vertical-align: middle;

  &::after {
    content: ' ';
    position: absolute;
    height: 15px;
    width: 1px;
    left: ${-THEME.GRID_SPACING}px;
    top: calc(50% - 7.5px);
    opacity: 0.6;
    background-color: ${THEME.COLOR_GREY};
  }

  &:first-child::after {
    display: none;
  }

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    &::after {
      display: none;
    }
  }
`;
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map